import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useAnalytics, ANALYTICS_EVENTS } from '@/hooks/useAnalytics'
import { configSelectors } from '@/store/configs'
import { detectWebView, detectWebViewSource } from '@/utils/webview'

const STORAGE_KEY = 'ga_is_webview_open'

const getSessionStorage = () => {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

export default function AnalyticsWebViewTracking() {
  const isInAppConfig = useSelector(configSelectors.selectIsInApp)
  const analytics = useAnalytics()
  const didTrackRef = useRef(false)
  const attemptsRef = useRef(0)

  useEffect(() => {
    if (didTrackRef.current) return
    const storage = getSessionStorage()
    if (storage?.getItem(STORAGE_KEY)) {
      didTrackRef.current = true
      return
    }

    const isInAppFlag = isInAppConfig === true
    const shouldFallback = isInAppConfig === null || typeof isInAppConfig === 'undefined'
    const fallbackDetected = shouldFallback && detectWebView()
    const shouldTrack = isInAppFlag || fallbackDetected
    if (!shouldTrack) return

    let timeoutId
    const detection = isInAppFlag ? 'queryParam' : detectWebViewSource()
    const maxAttempts = 10

    const attemptTrack = () => {
      if (didTrackRef.current) return
      if (typeof window.gtag !== 'function') {
        attemptsRef.current += 1
        if (attemptsRef.current >= maxAttempts) return
        timeoutId = window.setTimeout(attemptTrack, 300)
        return
      }
      analytics.track(ANALYTICS_EVENTS.WEBVIEW_OPEN, { detection })
      didTrackRef.current = true
      storage?.setItem(STORAGE_KEY, '1')
    }

    attemptTrack()

    return () => {
      if (timeoutId) window.clearTimeout(timeoutId)
    }
  }, [analytics, isInAppConfig])

  return null
}
